module.exports = __webpack_public_path__ + "img/9d2401ff05919d6e330a63c7e951c396.png";